// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Nu-z","giftOrPromoSelector":"Ou-z","disabled":"Pu-z","subTitle":"Qu-z","selectShipAddressMessage":"Ru-z","changePayment":"Su-z"};